import { REGISTRAR_ACTIVIDAD, RegistrarActividad } from '../types/actividad'

export const registrarActividadAction = (): RegistrarActividad => {
  return {
    type: REGISTRAR_ACTIVIDAD,
    payload: null,
  }
}
